export default "__VITE_ASSET__Bj_X9iSL__"